import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import { Dialog } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/hermes-duty-theme.css'
import './styles/hermes-duty-common.css'

Vue.config.productionTip = false
Dialog.props.closeOnClickModal.default = false
Vue.use(ElementUI)

Vue.mixin({
  computed: {
    canDelete() {
      return this.$store.getters['auth/canDelete']
    },
    canAccess() {
      return this.$store.getters['auth/canAccess']
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
